import Main from '../sections/Main';
import Hero from '../sections/Hero';

function LandingPage() {
  return (
    <>
      <Hero />
      <Main />
    </>
  );
}

export default LandingPage;
